/**
 * @param {*} value
 * @returns {*}
 */
function noSpaces ({ value }) {
  if (!value) return
  return value
    .toString()
    .replace(/\s/g, '')
}

module.exports = { noSpaces }
